// 초를 ms로 변환
export const secToMs = (sec) => {
  return sec * 1000;
};

// 분을 ms로 변환
export const minToMs = (min) => {
  return min * 60 * 1000;
};
